
  import RegistrationOrLoginDialog from '@/components/candidate/RegistrationOrLoginDialog';
  import JobAlertDialog from '@/components/JobAlertDialog';
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    components: {
      RegistrationOrLoginDialog,
      JobAlertDialog,
    },
    mixins: [ScreenSize],
    props: {
      jobPosting: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
  };
